/**
 * @prettier
 */

const SendEmailToast = ({
    message,
    isVisible,
    onDismiss,
    dismissLabel,
    isError = false,
}) => {
    return (
        <div className="grouplink-send-toast-slot" aria-live="polite">
            {isVisible && (
                <div
                    className={
                        isError
                            ? "grouplink-send-toast grouplink-send-toast-error"
                            : "grouplink-send-toast"
                    }
                    role={isError ? "alert" : "status"}
                >
                    <span className="grouplink-send-toast-icon" aria-hidden="true">
                        {isError ? (
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle
                                    cx="8"
                                    cy="8"
                                    r="6.5"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                />
                                <path
                                    d="M8 4.75V8.5"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                                <circle
                                    cx="8"
                                    cy="10.75"
                                    r="0.85"
                                    fill="currentColor"
                                />
                            </svg>
                        ) : (
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M7.5 13.475L4.025 10L3 11.025L7.5 15.525L17 6.025L15.975 5L7.5 13.475Z"
                                    fill="currentColor"
                                />
                            </svg>
                        )}
                    </span>
                    <p className="grouplink-send-toast-message">{message}</p>
                    <button
                        type="button"
                        className="grouplink-send-toast-dismiss"
                        onClick={onDismiss}
                        aria-label={dismissLabel}
                        id="grouplink-send-toast-dismiss-button"
                    >
                        <svg
                            width="12"
                            height="12"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                d="M1 1L13 13M13 1L1 13"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                        </svg>
                    </button>
                </div>
            )}
        </div>
    );
};

export default SendEmailToast;
